// COLLECTION OF VUE DIRECTIVES
// import { VueMaskDirective } from 'v-mask'

const globalDirectives = {
    // install(Vue) {
    //     // Vue.directive('mask', VueMaskDirective);
    // }
}

export default globalDirectives;